import { render, staticRenderFns } from "./indexFooter.vue?vue&type=template&id=ca1a53d8&scoped=true"
import script from "./indexFooter.vue?vue&type=script&lang=js"
export * from "./indexFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1a53d8",
  null
  
)

export default component.exports